// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoBlock_video__d_2aI"};